import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import { type GetIntegrationProductListRequestDto } from "../../dtos/get-integration-product-list-request-dto";
import type { GetIntegrationProductListResponseDto } from "../../dtos/get-integration-product-list-response-dto";
import { ProductQueryKeys } from "../../generators/product-query-keys";
import { ProductService } from "../../services/product-service";

type UseGetIntegrationProductListQueryProps = {
  queryParams: GetIntegrationProductListRequestDto;
  options?: Omit<
    UseQueryOptions<GetIntegrationProductListResponseDto>,
    "queryKey"
  >;
};

export const useGetIntegrationProductListQuery = ({
  queryParams,
  options
}: UseGetIntegrationProductListQueryProps) => {
  return useQuery({
    queryKey: ProductQueryKeys.getIntegrationProductList({
      ...queryParams
    }).queryKey,
    queryFn: async () =>
      await ProductService.getIntegrationProductList({ payload: queryParams }),
    ...options
  });
};
